import { useNavigate } from "react-router-dom";
import ActivateLicenseInitial from "../../component/SystemSettings/ActivateLicense/ActivateLicenseInitial";
import { useContext, useEffect, useState } from "react";
import { Context } from "../..";
import { AppContext } from "../../App";
import { isAxiosError } from "axios";

const NoLicense = () => {
    const navigate = useNavigate();
    const { store } = useContext(Context);
    const { showToast } = useContext(AppContext);
    const [serverId, setServerId] = useState<string>();

    useEffect(() => {
        (async () => {
            try {
                const serverIdRes = await store.licenseService.getServerId();
                setServerId(serverIdRes.data.id);
            } catch (err) {
                if (isAxiosError(err)) showToast(err.response?.data.message);
            }
        })();
    }, []);

    const handleActivate = async () => {
        await store.checkAvailableModules();
        navigate("/projects");
    };

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <ActivateLicenseInitial
                onActivate={handleActivate}
                serverId={serverId}
            />
        </div>
    );
};

export default NoLicense;
